"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mkAutoRegistry = void 0;
const Record_1 = require("./Record");
function mkAutoRegistry(values) {
    const registrar = {};
    return {
        values() {
            return Object.values(registrar);
        },
        has(key) {
            return (0, Record_1.hasValue)(registrar, key);
        },
        register(type) {
            return (ctor) => {
                registrar[type] = new ctor();
            };
        },
        getItem(key) {
            return (0, Record_1.getValueOrThrow)(registrar, key, `Expected type ${values[key]}(${key}) to have a handler.`);
        }
    };
}
exports.mkAutoRegistry = mkAutoRegistry;
